import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";

/**
 * Hook to check if the current user can manage IdP groups.
 * "Manage" means: map new IdP groups, edit IdP group details, or delete IdP group mappings.
 * This does NOT control role binding management.
 *
 * @returns {boolean} true if user is a root admin
 */
const useCanManageIdpGroups = (): boolean => {
  const { viewer } = useTypedContext(AccountContext);
  return viewer.admin;
};

export default useCanManageIdpGroups;
